// gnav
jQuery(function($) {
  if (!$('#is-exform').length) {
    var $modalNav = $('#js-gnav');
    var $trigger = $('#js-gnav-trigger');
    if ($modalNav.length && $trigger.length) {
      var $closeTrigger = $('#js-gnav > ul a, #js-modal-layer');
      var $layer = $('#js-modal-layer');
      var $header = $('#js-header');
      $trigger.on('click', function() {
        $(this).toggleClass('is-active');
        if ($(this).hasClass('is-active')) {
          $modalNav.addClass('is-active');
          $header.addClass('has-bg');
          $layer.addClass('is-active');
        } else {
          $modalNav.removeClass('is-active');
          $header.removeClass('has-bg');
          $layer.removeClass('is-active');
        }
      });
      $closeTrigger.on('click', function() {
        $modalNav.removeClass('is-active');
        $layer.removeClass('is-active');
        $trigger.removeClass('is-active');
        $header.removeClass('has-bg');
      });
      console.log('gnav is exist(static)');
    } else {
      console.log('gnav is not exist');
    }
  }
});
